import { MARQUEE_ITEMS } from "../data/siteContent";

function MarqueeList({ ariaHidden }) {
  return (
    <div className="flex items-center shrink-0" aria-hidden={ariaHidden ? "true" : undefined}>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center shrink-0">
          <span className="font-display italic text-xl sm:text-2xl text-ivory-dim px-6 sm:px-10 whitespace-nowrap">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-gold shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee relative border-y border-gold/10 bg-ink-soft/40 py-5 overflow-hidden"
    >
      <div className="marquee-track">
        <MarqueeList ariaHidden={false} />
        <MarqueeList ariaHidden={true} />
      </div>
    </div>
  );
}
